"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UserRow;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _numeral = _interopRequireDefault(require("numeral"));
var _moment = _interopRequireDefault(require("moment"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _Routing = require("Functions/Routing");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function UserRow(_ref) {
  let {
    data,
    blank = false,
    fields
  } = _ref;
  _numeral.default.locale('en');
  _moment.default.locale('fr');
  const userLogin = window.app.state.session.user.login;
  const blank_props = blank === true ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {};
  const link = /*#__PURE__*/_react.default.createElement(_Link.default, (0, _extends2.default)({
    className: "u-link-only"
  }, blank_props, {
    href: (0, _Routing.URL)('AdminUsersDashboard') + '/' + data.id
  }), "Fiche de l'utilisateur");
  let output = /*#__PURE__*/_react.default.createElement("div", {
    className: userLogin === data.login ? "c-dashboard__row blue_row" : "c-dashboard__row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "c-dashboard__cell User-login"
  }, data.login, link), /*#__PURE__*/_react.default.createElement("div", {
    className: "c-dashboard__cell "
  }, data.name, link), /*#__PURE__*/_react.default.createElement("div", {
    className: "c-dashboard__cell "
  }, data.firstname, link), /*#__PURE__*/_react.default.createElement("div", {
    className: "c-dashboard__cell "
  }, data.phone), /*#__PURE__*/_react.default.createElement("div", {
    className: "c-dashboard__cell "
  }, data.activity));
  return output;
}
